import React, { useEffect, useState } from 'react';
import logo_sticky from '../../../styles/medias/images/logo-sticky.svg';
import logo from '../../../styles/medias/images/logo.svg';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { Link } from 'gatsby';
import useFetch from '../../hooks/useFetch';

const Header = () => {
	const [headerStyle, setHeaderStyle] = useState('');
	const [reload] = useState({ endPoint: null, isClicked: 0 });
	const productResponse = useFetch(`produits/`, [{}], reload);
	const offerResponse = useFetch(`linked-offers?populate=*`, [{}], reload);
	//console.log('productResponse', productResponse);
	var imageURL =
		offerResponse &&
		offerResponse.data &&
		offerResponse.data[0].featured_image &&
		offerResponse.data[0].featured_image.data.attributes.url;
	//	console.log('imageURL', imageURL);
	const [imageProduct, setImageProduct] = useState(null);
	

	const handeleHover = (offer) => {
		if (offer && offer.featured_image) {
			imageURL = offer.featured_image?.data?.attributes?.url;
			setImageProduct(`${imageURL}`);
		}
	};

	useScrollPosition(({ prevPos, currPos }) => {
		if (currPos.y < -150) {
			setHeaderStyle('fixed');
		} else {
			setHeaderStyle('');
		}
	});
	const [menuActive, setMenuState] = useState(false);
	return (
		<header className={headerStyle}>
			<div className="search__form">
				<div className="container">
					<form>
						<div className="form-group">
							<input type="text" placeholder="Que recherchez-vous ?" />
							<button type="submit">ok</button>
						</div>
					</form>
					<div className="close">&nbsp;</div>
				</div>
			</div>

			<div className="header-top">
				<div className="header__top-bloc">
					<div className="menu_left">
						<ul>
							<li>
								<Link to="/mentionlegal">Mentions Légales</Link>

							</li>
							<li>
								<Link to="/cgu">CGU</Link>

							</li>
							<li>
								<Link to="/faq">Faq</Link>

							</li>
							<li>
								<a href="/">PLAN DU SITE</a>
							</li>
						</ul>
					</div>
					<div className="menu_right">
						<ul>
							<li>
								<a href="/">+212 0522 42 95 95</a>
							</li>
							<li>
								<a href="/">NOS AGENCES</a>
							</li>
							<li>
								<span>AR</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="header-bottom">
				<div className="header__blocleft">
					<div className="logo">
						<Link to="/">
							<img src={logo} />
							<img className="img-sticky" src={logo_sticky} />
						</Link>
					</div>
					<div className={`menu o-nav ${menuActive ? 'is-inViewport' : ''}`}>
						<ul>
							<li>
								<Link to="/" className="active">
									Accueil
								</Link>
							</li>
							<li>
								<a>Maroc leasing</a>
								<ul>
									<li>
										<Link to="/apropos">A propos</Link>
									</li>
									<li>
										<Link to="/equipe">Comité de direction</Link>
									</li>
									<li>
										{/* <a href="/reseau">Notre réseau</a> */}
										<Link to="/reseau">Notre réseau</Link>

									</li>
								</ul>
							</li>
							<li className="submenu_mega">
								<a href="">Nos produits</a>
								<ul className="megamenu">
									<div className="container">
										<div className="row">
											<div className="col-md-4 first-col">
												<ul>
													{productResponse.complete &&
														productResponse.data &&
														productResponse.data.map((product, idx) => {
															return (
																<li key={idx}>
																	<Link to={`/products/?id=${product.id}`} params={{ product }}>
																		{product.titre}
																	</Link>
																</li>
															);
														})}
												</ul>
											</div>
											<div className="col-md-8 last-col">
												<div className="list">
													<h4>Nos offres</h4>
													<ul>
														{offerResponse.complete &&
															offerResponse.data &&
															offerResponse.data.map((offer, idx) => {
																return (
																	<li key={idx}>
																		<Link
																			to={`/offers/?id=${offer.id}`}
																			params={{ offer }}
																			onMouseEnter={() => handeleHover(offer)}
																		>
																			{offer.title}
																			<span>{offer.descriptionmenu}</span>
																		</Link>
																	</li>
																);
															})}
														{/* <li>
															<a href="/">
																Libertis Pro<span>Lorem ipsum dolor sit amet.</span>
															</a>
														</li>
														<li>
															<a href="/">
																Al Moukawil Chaabi Lease<span>Lorem ipsum dolor sit amet.</span>
															</a>
														</li>
														<li> 
															<a href="/offrenakl">
																Nakl Leasing<span>Lorem ipsum dolor sit amet.</span>
															</a>
														</li>*/}
													</ul>
												</div>
												<div className="image">
													{/* <img src={require('../../../styles/medias/images/medical-img.png')} /> */}
													{imageProduct ? (
														<img src={`${process.env.GATSBY_API_URL_FILE}`+imageProduct} />
													) : (
														<img src={`${process.env.GATSBY_API_URL_FILE}`+imageURL} />
													)}
												</div>
											</div>
										</div>
									</div>
								</ul>
							</li>
							<li>
								<a>Média</a>
								<ul>
									<li>
										{/* <a href="/publication">Nos Publications</a> */}
										<Link to="/publication" >
										Communication financière
								</Link>
									</li>
									<li>
										<Link to="/">Actualité</Link>
										{/* <Link to="/actualite">Actualité</Link> */}
										
									</li>
									<li>
										<Link to="/presse">Presse</Link>
									</li>
								</ul>
							</li>
							<li>
								<Link to="/contact" className="active">
									Contact
								</Link>
							</li>
						</ul>
					</div>
				</div>

				<div className="header__blocright">
					<div className="header__bottom-bloc">
						<div className={`col__menu--mobile ${menuActive ? 'is-active-top' : ''}`}>
							<div
								className={`c-nav__icon ${menuActive ? 'is-active' : ''}`}
								onClick={() => setMenuState(!menuActive)}
							>
								<span></span>
							</div>
						</div>
						<div className="espace-fournisseur">
							<a target="_blank" href={process.env.GATSBY_API_URL_LEASING}>
								
								Simulation EN LIGNE
							</a>
						</div>
						<div className="espace-client">
							<a href={process.env.GATSBY_API_URL_MLNET} target="_blank">
								Espace client
							</a>
						</div>
						<div className="espace-partenaire">
						<a href={process.env.GATSBY_API_URL_MARKETPLACE} target="_blank">
								Market place
							</a>
						</div>
						{
						//	<div className="market-place">
					//		<a href={process.env.GATSBY_API_URL_MARKETPLACE} target="_blank">
					//			Market place
					//		</a>
					//	</div>
}
					</div>
				</div>
			</div>
		</header>
	);
};
export default Header;
